<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import CustomNotification from '@/components/common/CustomNotification.vue'
import { mapGetters } from 'vuex'
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
import CustomAlert from '@/components/common/CustomAlert.vue'

export default {
  name: 'ChangeEmail',
  components: { CustomAlert, CustomNotification },
  mixins: [validationMixin, fieldValidationsMixin],
  validations: {
    currentPwd: { required },
    newEmail: { required, email },
    currentPwdForEmail: { required }
  },
  data: () => ({
    errorContext: "",
    errorMessage: '',
    currentPwdForEmail: '',
    newEmail: '',
    submitError: false,
    showEmailNotification: false,
    emailChangeStatus: { type: 'error', msg: '' },
    showCurrentPwdForEmail: false,
    wrongCurrentPwdForEmail: false
  }),
  computed: {
    ...mapGetters(['locale']),
    currentPwdForEmailErrors() {
      const errors = []
      if (!this.$v.currentPwdForEmail.$dirty) return errors
      !this.$v.currentPwdForEmail.required &&
      errors.push(this.$t('validation.password.required'))
      this.wrongCurrentPwdForEmail &&
      errors.push(this.$t('validation.current.password.mismatch'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.newEmail.$dirty) return errors
      !this.$v.newEmail.required &&
      errors.push(this.$t('validation.email.required'))
      !this.$v.newEmail.email &&
      errors.push(this.$t('validation.email.invalid'))
      !this.$v.newEmail.required &&
      errors.push(this.$t('validation.email.required'))
      return errors
    }
  },
  watch: {
    '.$error': {
      handler(hasError) {
        if (!hasError && this.submitError) this.submitError = false},
      deep: true
    }
  },
  methods: {
    submitEmailChange() {
      this.$v.currentPwdForEmail.$touch()
      this.$v.newEmail.$touch()
      this.submitError = false
      this.errorMessage = ""
      this.errorContext = ""
      if (this.$v.currentPwdForEmail.$invalid || this.$v.newEmail.$invalid) {
        this.submitError = true
        this.errorMessage = this.$t( "validation.form.incomplete")
        this.errorContext = "email"
        return
      }
      this.$userService
        .sendChangeEmailMail({
          currentPassword: this.currentPwdForEmail,
          newEmail: this.newEmail,
          emailChangeUrl: `${window.config.VUE_APP_BASE_URL}/confirmEmailChange` })
        .then(() => {
          this.submitError = false
          this.showEmailNotification = true
          this.emailChangeStatus = { type: "success", msg:
              this.$t("component.profile.accountManagement.email.change.request")}})
        .catch((e) => {
          this.submitError = true
          this.errorMessage =
            e.response?.status === 400
              ? this.$t("validation.current.password.mismatch")
              : e.response?.status === 409
                ? this.$t('component.profile.accountManagement.email.taken')
                : e.fromCms ? e.message : this.$cms.get(this.content, e.response?.status || this.$t('validation.form.incomplete'))
          this.errorContext = "email"}) }
  }
}
</script>
<template>
  <div>
    <CustomNotification
      :show-notification="showEmailNotification"
      :notification-type="emailChangeStatus.type"
      :timeout= 5000>
      <span class="body-2">{{ emailChangeStatus.msg }}</span>
    </CustomNotification>
    <v-card flat tile outlined color="transparent" class="pa-4">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="12" md="6">
            <!-- Email Change Section -->
            <v-row class="mb-4">
              <v-col>
                <v-card outlined>
                  <v-card-title>
                    <v-spacer />
                    <v-row class="pl-2">
                      <v-col cols="12" class="justify-center">
                        <span>{{ $t('component.profile.accountManagement.change.email.header') }}</span>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <CustomAlert
                      v-if="submitError && errorContext === 'email'"
                      alert-type="error"
                      :show-alert="submitError"
                      @update:show-alert="submitError = $event">
                      <span class="body-2 cms_validatorMsg">{{ errorMessage }}</span>
                    </CustomAlert>
                    <v-text-field
                      id="newEmail"
                      v-model="newEmail"
                      class="cms_eMail"
                      :label="$t('component.profile.accountManagement.new.email')"
                      :error-messages="emailErrors"
                      outlined
                      dense
                      required
                      @input="$v.newEmail.$touch()"
                      @keyup.enter.native="submitEmailChange()"
                    ></v-text-field>
                    <v-row>
                      <v-col>
                        <v-text-field
                          id="currentPwdForEmail"
                          v-model="currentPwdForEmail"
                          class="cms_pw"
                          :label="$t('component.profile.accountManagement.current.password')"
                          :error-messages="currentPwdForEmailErrors"
                          :type="showCurrentPwdForEmail ? 'text' : 'password'"
                          :append-icon="
                        showCurrentPwdForEmail ? 'mdi-eye' : 'mdi-eye-off'  "
                          outlined
                          dense
                          required
                          @input="$v.currentPwdForEmail.$touch()"
                          @click:append="
                        showCurrentPwdForEmail = !showCurrentPwdForEmail "
                          @keyup.enter.native="submitEmailChange()"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-row class="text-center">
                      <v-col class="pt-0">
                        <v-btn
                          id="sendChangeEmailMail"
                          class="text-center px-8"
                          color="primary"
                          depressed
                          @click.stop="submitEmailChange">
                          {{ $t('button.change.email') }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>